export default __webpack_public_path__ + "static/media/rach-whitebkgd-1.e64a6275.png";